export default "__VITE_ASSET__82ede849__"